import styled from 'styled-components'

const RichText = styled.div`
  p {
    ${({ theme }) => theme.textStyleBigParagraph}
    color: ${({ theme }) => theme.text};

    &:not(:last-of-type) {
      margin-bottom: 1rem;
    }
  }
  a {
    color: ${({ theme }) => theme.links};
    &:hover {
      text-decoration: underline;
    }
  }
`
export default RichText
